export const SUBMIT_PRICING_VARIABLES = 'SUBMIT_PRICING_VARIABLES';
export const SET_FINAL_PRICE = 'SET_FINAL_PRICE';